import type { RatingResult } from '@core-api/presentation/types/response';
import type { SlidePreviewResultsInputs } from '../../types';

const makeRatingResult = (
  interactiveContentChoiceId: string,
  x: number,
  y: number,
): RatingResult => {
  const score = { x, y };
  return {
    interactiveContentChoiceId,
    responses: [score],
    average: score,
  };
};

export const getPreviewResultsIteration = ({
  previous = [],
  iteration,
  extras: { choices, range },
}: SlidePreviewResultsInputs<RatingResult>): RatingResult[] => {
  const fullRange = range.max - range.min;

  if (iteration === 0 || previous.length === 0) {
    return choices.map((choice) =>
      makeRatingResult(
        choice.interactiveContentChoiceId,
        Math.floor(Math.random() * fullRange + range.min) + 1,
        Math.floor(Math.random() * fullRange + range.min) + 1,
      ),
    );
  }

  return previous.map((result) => {
    const deltaX = (Math.random() - 0.5) * (fullRange / 4);
    const deltaY = (Math.random() - 0.5) * (fullRange / 4);

    const newX = Math.min(
      Math.max((result.average?.x ?? range.min) + deltaX, range.min),
      range.max,
    );
    const newY = Math.min(
      Math.max((result.average?.y ?? range.min) + deltaY, range.min),
      range.max,
    );

    return makeRatingResult(result.interactiveContentChoiceId, newX, newY);
  });
};
